module.exports = __webpack_public_path__ + "static/media/game_phone_frame.d3be9d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/component/Game/img/game_phone_frame.png
// module id = 155
// module chunks = 0